<app-header-simple></app-header-simple>
<!-- ======= Hero Section ======= -->
<section id="hero" class="d-flex flex-column justify-content-end align-items-center">
    <div id="heroCarousel" class="container carousel carousel-fade" data-ride="carousel">

        <!-- Titulo -->
        <div class="carousel-item active">
            <div class="carousel-container" style="height: 100%;">
                <h2 class="mt-4 animate__animated animate__faster animate__fadeInDown" style="margin-bottom: 0px;">
                    Ver Quiniela
                </h2>
                <div class="text-center text-white" *ngIf="!isLoading">Nombre: {{this.jugador.nombre}} {{jugador.apellido}} , Puntos: {{this.jugador.puntaje}} , Quiniela N°: {{this.jugador.numero}}</div>

                <a routerLink="/tabla/{{ quiniela.$key }}" *ngIf="this.quiniela.activa" class="btn-get-started animate__animated animate__faster animate__fadeInDown" style="padding: .25rem .5rem;font-size: .875rem;line-height: 1.5;width: 230px;">
                    <i class="icofont-arrow-left"></i> Tabla de puntuación</a>

                <marquee>
                    <p class="d-block d-sm-block d-md-none" style="font-size: 0.90rem;margin-bottom: 0px;">
                        <b>Recuerda que si pulsas sobre algún partido puedes ver los pronosticos de todos los jugadores en ese partido</b>
                    </p>
                </marquee>

                <section id="services" class="services" style="padding: 1rem;width: 100%;padding-top: 0px;">
                    <app-loader *ngIf="isLoading"></app-loader>
                    <div *ngIf="!isLoading">
                        <!-- Tabla para escritorio -->
                        <div class="table-responsive mt-3 d-none d-sm-none d-md-block">
                            <table class="table table-bordered table-sm animate__animated animate__faster animate__fadeInDown" id="tablePartidos">
                                <thead>
                                    <tr>
                                        <th class="text-white d-none d-sm-none d-md-block" scope="col">Fecha</th>
                                        <th scope="col" class="text-center text-white">EQUIPO 1</th>
                                        <th scope="col" class="text-center text-white" colspan="2" style="border-top: 0px;"></th>
                                        <th scope="col" class="text-center text-white">EQUIPO 2</th>
                                        <th scope="col" class="text-center text-white" colspan="2">Resultado Final</th>
                                        <th scope="col" class="text-center text-white">PTS</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let partidos of this.partidosByJugador; let i = index ">
                                        <td class="d-none d-sm-none d-md-block"><a routerLink="/partido/{{partidos.id_partido}}" style="text-decoration: none;color: white;">{{partidos.fecha}}</a></td>
                                        <td><a routerLink="/partido/{{partidos.id_partido}}" style="text-decoration: none;color: white;">{{partidos.contrincante1}}</a>
                                        </td>
                                        <td><a routerLink="/partido/{{partidos.id_partido}}" style="text-decoration: none;color: white;">{{partidos.resultado1}}</a>
                                        </td>
                                        <td><a routerLink="/partido/{{partidos.id_partido}}" style="text-decoration: none;color: white;">{{partidos.resultado2}}</a>
                                        </td>
                                        <td><a routerLink="/partido/{{partidos.id_partido}}" style="text-decoration: none;color: white;">{{partidos.contrincante2}}</a>
                                        </td>
                                        <!--Aqui agrupo para la puntuacion si existe lo imprimo si no existe es que no se ga jugado-->
                                        <td *ngIf="this.partidosJugados.has(partidos.id_partido)"><a routerLink="/partido/{{partidos.id_partido}}" style="text-decoration: none;color: white;">{{this.partidosJugados.get(partidos.id_partido).resultado1}}</a>
                                        </td>
                                        <td *ngIf="this.partidosJugados.has(partidos.id_partido)"><a routerLink="/partido/{{partidos.id_partido}}" style="text-decoration: none;color: white;">{{this.partidosJugados.get(partidos.id_partido).resultado2}}</a></td>

                                        <!--En caso de que no exista-->
                                        <td *ngIf="!this.partidosJugados.has(partidos.id_partido)"><a routerLink="/partido/{{partidos.id_partido}}" style="text-decoration: none;color: white;">-</a>
                                        </td>
                                        <td *ngIf="!this.partidosJugados.has(partidos.id_partido)"><a routerLink="/partido/{{partidos.id_partido}}" style="text-decoration: none;color: white;">-</a></td>


                                        <!--AQUI USAMOS EL CACHE GENERADO PARA SABER SI YA SE JUGO O NO EL PARTIDO-->
                                        <td *ngIf="this.partidosJugados.has(partidos.id_partido)"><a routerLink="/partido/{{partidos.id_partido}}" style="text-decoration: none;color: white;">{{partidos.ppr
                                                + partidos.ppe}}</a></td>
                                        <td *ngIf="!this.partidosJugados.has(partidos.id_partido)"><a routerLink="/partido/{{partidos.id_partido}}" style="text-decoration: none;color: white;">-</a></td>

                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <!-- Tabla para moviles -->
                        <div class="table-responsive mt-3 d-block d-sm-block d-md-none">
                            <table class="table table-bordered table-sm animate__animated animate__faster animate__fadeInDown" id="tablePartidos">
                                <thead>
                                    <tr>
                                        <th class="text-white d-none d-sm-none d-md-block" scope="col">Fecha</th>
                                        <th scope="col" class="text-center text-white">EQUIPO 1</th>
                                        <th scope="col" class="text-center text-white" colspan="2" style="border-top: 0px;"></th>
                                        <th scope="col" class="text-center text-white">EQUIPO 2</th>
                                        <th scope="col" class="text-center text-white" colspan="2">Res</th>
                                        <th scope="col" class="text-center text-white">PTS</th>

                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let partidos of this.partidosByJugador; let i = index ">
                                        <td class="d-none d-sm-none d-md-block"><a routerLink="/partido/{{partidos.id_partido}}" style="text-decoration: none;color: white;">{{partidos.fecha}}</a></td>
                                        <td><a routerLink="/partido/{{partidos.id_partido}}" style="text-decoration: none;color: white;">{{partidos.contrincante1.substring(0, 8)}}</a>
                                        </td>
                                        <td><a routerLink="/partido/{{partidos.id_partido}}" style="text-decoration: none;color: white;">{{partidos.resultado1}}</a>
                                        </td>
                                        <td><a routerLink="/partido/{{partidos.id_partido}}" style="text-decoration: none;color: white;">{{partidos.resultado2}}</a>
                                        </td>
                                        <td><a routerLink="/partido/{{partidos.id_partido}}" style="text-decoration: none;color: white;">{{partidos.contrincante2.substring(0, 8)}}</a>
                                        </td>
                                        <!--Aqui agrupo para la puntuacion si existe lo imprimo si no existe es que no se ga jugado-->
                                        <td *ngIf="this.partidosJugados.has(partidos.id_partido)"><a routerLink="/partido/{{partidos.id_partido}}" style="text-decoration: none;color: white;">{{this.partidosJugados.get(partidos.id_partido).resultado1}}</a>
                                        </td>
                                        <td *ngIf="this.partidosJugados.has(partidos.id_partido)"><a routerLink="/partido/{{partidos.id_partido}}" style="text-decoration: none;color: white;">{{this.partidosJugados.get(partidos.id_partido).resultado2}}</a></td>

                                        <!--En caso de que no exista-->
                                        <td *ngIf="!this.partidosJugados.has(partidos.id_partido)"><a routerLink="/partido/{{partidos.id_partido}}" style="text-decoration: none;color: white;">-</a>
                                        </td>
                                        <td *ngIf="!this.partidosJugados.has(partidos.id_partido)"><a routerLink="/partido/{{partidos.id_partido}}" style="text-decoration: none;color: white;">-</a></td>




                                        <!--AQUI USAMOS EL CACHE GENERADO PARA SABER SI YA SE JUGO O NO EL PARTIDO-->
                                        <td *ngIf="this.partidosJugados.has(partidos.id_partido)"><a routerLink="/partido/{{partidos.id_partido}}" style="text-decoration: none;color: white;">{{partidos.ppr
                                            + partidos.ppe}}</a></td>
                                        <td *ngIf="!this.partidosJugados.has(partidos.id_partido)"><a routerLink="/partido/{{partidos.id_partido}}" style="text-decoration: none;color: white;">-</a></td>


                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="alert alert-dark animate__animated animate__faster animate__fadeInDown" role="alert">
                            Si presenta algún inconveniente puede comunicarse al email {{quiniela.email}} o al teléfono {{quiniela.telefono}}
                        </div>
                    </div>
                </section>
                <!-- End Services Section -->
            </div>
        </div>
    </div>



    <svg class="hero-waves" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 24 150 28 " preserveAspectRatio="none">
        <defs>
            <path id="wave-path" d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z" />
        </defs>
        <g class="wave1">
            <use xlink:href="#wave-path" x="50" y="3" fill="rgba(255,255,255, .1)" />
        </g>
        <g class="wave2">
            <use xlink:href="#wave-path" x="50" y="0" fill="rgba(255,255,255, .2)" />
        </g>
        <g class="wave3">
            <use xlink:href="#wave-path" x="50" y="9" fill="#fff" />
        </g>
    </svg>


</section>
<!-- End Hero -->